import {
  Avatar,
  Box,
  Flex,
  Stack,
  Text,
  Tooltip,
  useColorMode,
  useColorModeValue,
  Button,
  useToast,
} from "@chakra-ui/react";
import { EditProfile } from "./components/EditProfile";
import { UserProfile } from "../../context/userProfileContext";
import Container from "../../components/Container";
import Header from "../../components/Header";
import Notifications from "./components/Notifications";
import { MdDarkMode, MdOutlineLightMode } from "react-icons/md";
import { useState, useEffect, useContext } from "react";
import { COLORS } from "../../constants/colors";
import { AuthContext } from "../../context/authContext";
import axiosInstance from "../../services/api";
import { 
  subscribeToPushNotifications, 
  requestNotificationPermission,
  unsubscribeFromPushNotifications 
} from "../../services/notificationService";

const Settings = () => {
  const [mode, setMode] = useState("light");
  const { toggleColorMode } = useColorMode();
  const cardBg = useColorModeValue(COLORS.primary, COLORS.bgGrey);
  const appTextColor = useColorModeValue(COLORS.white, COLORS.black);
  const modeColor = useColorModeValue(COLORS.grey, COLORS.white);
  const { userProfile } = UserProfile();
  const { tenantName, email } = userProfile;
  const [isSubscribed, setIsSubscribed] = useState(false);
  const toast = useToast();
  const { userInfo } = useContext(AuthContext);
  const { userId } = userInfo;

  console.log(userProfile, "profile")

  useEffect(() => {
    checkSubscriptionStatus();
  }, []);

  const checkSubscriptionStatus = async () => {
    try {
      if ('serviceWorker' in navigator) {
        const registration = await navigator.serviceWorker.ready;
        const subscription = await registration.pushManager.getSubscription();
        setIsSubscribed(!!subscription);
      }
    } catch (error) {
      console.error('Error checking subscription status:', error);
    }
  };

  const handleSubscribe = async () => {
    try {
      // First unsubscribe from any existing subscription
      if (isSubscribed) {
        await unsubscribeFromPushNotifications(userId);
        setIsSubscribed(false);
      }

      // Then request permission and create new subscription
      const permissionGranted = await requestNotificationPermission();
      if (permissionGranted) {
        const subscribed = await subscribeToPushNotifications(userId);
        
        if (subscribed) {
          setIsSubscribed(true);
          toast({
            title: 'Notifications enabled',
            description: 'You will now receive notifications',
            status: 'success',
            duration: 5000,
            isClosable: true,
          });
        }
      }
    } catch (error) {
      console.error('Error subscribing to notifications:', error);
      toast({
        title: 'Error',
        description: 'Failed to enable notifications',
        status: 'error',
        duration: 5000,
        isClosable: true,
      });
      // Reset subscription status on error
      setIsSubscribed(false);
    }
  };

  // Add a separate function for unsubscribing
  const handleUnsubscribe = async () => {
    try {
      const unsubscribed = await unsubscribeFromPushNotifications(userId);
      if (unsubscribed) {
        setIsSubscribed(false);
        toast({
          title: 'Notifications disabled',
          description: 'You will no longer receive notifications',
          status: 'info',
          duration: 5000,
          isClosable: true,
        });
      }
    } catch (error) {
      console.error('Error unsubscribing from notifications:', error);
      toast({
        title: 'Error',
        description: 'Failed to disable notifications',
        status: 'error',
        duration: 5000,
        isClosable: true,
      });
    }
  };

  return (
    <>
      <Box shadow="sm">
        <Container>
          <Header />
        </Container>
      </Box>
      <Container>
        <Box my="40px" mx="5px">
          <Flex
            bg={cardBg}
            align="center"
            gap="2em"
            p="30px 20px"
            borderRadius="10px"
          >
            <Avatar
              src={userProfile?.profilePicture}
              size="xl"
              name={tenantName}
            />
            <Stack color={appTextColor}>
              {/* <Text fontSize='1.5rem'>{userProfile?.tenantName}</Text> */}
              <Tooltip label={tenantName}>
                <Text
                  fontSize={["18px", "20px"]}
                  fontWeight="bold"
                  isTruncated
                  maxWidth="170px"
                >
                  {tenantName}
                </Text>
              </Tooltip>
              <Tooltip label={email}>
                <Text fontSize={["15px", "16px"]} isTruncated maxWidth="170px">
                  {email}
                </Text>
              </Tooltip>
              <EditProfile />
            </Stack>
          </Flex>
          <Flex
            width="100%"
            align="center"
            justify="space-between"
            mt="1rem"
            bg="inherit"
            color={modeColor}
          >
            <Text fontWeight={"semibold"}>Display</Text>
            {mode === "dark" ? (
              <MdOutlineLightMode
                size={24}
                cursor="pointer"
                onClick={() => {
                  toggleColorMode();
                  setMode("light");
                }}
              />
            ) : (
              <MdDarkMode
                size={24}
                cursor="pointer"
                onClick={() => {
                  toggleColorMode();
                  setMode("dark");
                }}
              />
            )}
          </Flex>
          <Flex
            width="100%"
            align="center"
            justify="space-between"
            mt="1rem"
            bg="inherit"
            color={modeColor}
          >
            <Text fontWeight={"semibold"}>Push Notifications</Text>
            <Button
              onClick={isSubscribed ? handleUnsubscribe : handleSubscribe}
              colorScheme={isSubscribed ? 'red' : 'green'}
              size="sm"
            >
              {isSubscribed ? 'Disable Notifications' : 'Enable Notifications'}
            </Button>
          </Flex>
          <Notifications />

          

          {/* <MoreSettings /> */}
        </Box>
      </Container>
    </>
  );
};

export default Settings;
